import React from 'react'

import ReactMarkdown from 'react-markdown'

import style from './QuestionText.module.css'

import { CodeBlock } from 'common/components'
import { Task } from 'common/types/entities'

type PropsType = {
  currentTask: Task
}

export const QuestionText = ({ currentTask }: PropsType) => {
  return (
    <>
      <ReactMarkdown className={style.markdown}>{currentTask.questionText}</ReactMarkdown>
      {currentTask.code && (
        <CodeBlock language={currentTask.code.lang}>{currentTask.code.text}</CodeBlock>
      )}
      {currentTask.author && (
        <p className={style.author}>
          Вопрос предложен{' '}
          <a
            className={style.link}
            href={`https://github.com/${currentTask.author}`}
            target="_blank"
            rel="noreferrer"
          >
            {currentTask.author}
          </a>
        </p>
      )}
    </>
  )
}
